var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_5762)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 15.0098L22.0249 15V19.5858C22.0249 20.1381 21.5772 20.5858 21.0249 20.5858C20.7597 20.5858 20.5054 20.4804 20.3178 20.2929L18.0249 18H5C3.34315 18 2 16.6569 2 15V6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V15C22 15.0033 22 15.0065 22 15.0098ZM6.16795 10.5547C7.67758 12.8191 9.64567 14 12 14C14.3543 14 16.3224 12.8191 17.8321 10.5547C18.1384 10.0952 18.0142 9.4743 17.5547 9.16795C17.0952 8.8616 16.4743 8.98577 16.1679 9.4453C15.0109 11.1809 13.6457 12 12 12C10.3543 12 8.98909 11.1809 7.83205 9.4453C7.5257 8.98577 6.90483 8.8616 6.4453 9.16795C5.98577 9.4743 5.8616 10.0952 6.16795 10.5547Z",
    fill: "#B0B7C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_5762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.7fb846d3a6e1c75d20aff68a57e51dfe.svg";
export { ForwardRef as ReactComponent };